import { userManager } from "../../getOidc";
import { cookieInfo, deleteCookie } from "./handleCookies";

export const performLogout = (): void => {
  window.onbeforeunload = null;
  const loginCookie = cookieInfo("loginToken");

  if (!!loginCookie) {
    userManager
      .createSignoutRequest({
        id_token_hint: loginCookie && loginCookie.id_token,
      })
      .then((req) => {
        deleteCookie("loginToken");
        (window as any).location = req.url;
      });
  }
};
